import { createFileRoute } from "@tanstack/react-router";

import CompetitionCategories from "@/components/CompetitionProfile/CompetitionCategories";

const Component = () => {
  const { competitionUuid } = Route.useParams();

  return <CompetitionCategories competitionUuid={competitionUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/profile/categories")({
  component: Component,
});
